module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDguNiAxNDUuMTciPjx0aXRsZT5QbGF5MjwvdGl0bGU+PHBhdGggZD0iTTEwNi43LDY5LjI3LDYuMi42N0E0LDQsMCwwLDAsMi4xLjQ3LDQsNCwwLDAsMCwwLDR2MTM3LjJhMy45MiwzLjkyLDAsMCwwLDIuMSwzLjUsNC4xNCw0LjE0LDAsMCwwLDEuOS41LDMuODksMy44OSwwLDAsMCwyLjMtLjdsMTAwLjYtNjguNmEzLjksMy45LDAsMCwwLDEuNy0zLjNBNC4wOSw0LjA5LDAsMCwwLDEwNi43LDY5LjI3WiIgc3R5bGU9ImZpbGw6I2ZmZiIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/Hero/MainHero/Play.svg
// module id = 841
// module chunks = 0